import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { AcrConfigurationItem } from "./AcrConfigurationItem"

import type { AcrConfiguration } from "@/api/useIntegrations.types"
import type { AcrConfigurationTabProps } from "."

export const AcrConfigurationTab = (props: AcrConfigurationTabProps) => {
  const { t } = useTranslation()
  const [data] = useIntegration(props)
  const configuration = data?.configuration as AcrConfiguration | undefined
  const registries = configuration?.installations || []

  if (!registries.length) return <>{t("integrations.acr.noData")}</>

  return (
    <Flex vertical gap={8}>
      {registries.map((registry) => (
        <AcrConfigurationItem
          key={registry.registryUrl}
          registry={registry}
          {...props}
        />
      ))}
    </Flex>
  )
}
